import moment from 'moment';

export default {
  filters: {
    capitalize: function (value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    shortDate: function (value) {
      if (value) {
        return moment(String(value)).format('DD-MM-YYYY');
      }
    },
    money: function (value) {
      if (typeof value !== 'number') {
        return value;
      }
      let formatter = new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      });
      return formatter.format(value);
    },
    decimal: function (value, decimals) {
      if (typeof value !== 'number') {
        return value;
      }
      if (decimals === undefined) {
        decimals = 0;
      }
      let formatter = new Intl.NumberFormat('es-ES', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      });
      return formatter.format(value);
    }
  },
  create: function (Vue) {
    Object.keys(this.filters).forEach(function (filter, k) {
      Vue.filter(filter, this.filters[filter]);
    }.bind(this));
  }
};
